import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EOutboundReferralSource;
(function (EOutboundReferralSource) {
  EOutboundReferralSource["Upload"] = "upload";
  EOutboundReferralSource["Ui"] = "ui";
  EOutboundReferralSource["Integrator"] = "integrator";
})(EOutboundReferralSource || (EOutboundReferralSource = {}));
export let EOutboundReferralStatus;
(function (EOutboundReferralStatus) {
  EOutboundReferralStatus["Active"] = "active";
  EOutboundReferralStatus["Called"] = "called";
  EOutboundReferralStatus["Scheduled"] = "scheduled";
  EOutboundReferralStatus["Incomplete"] = "incomplete";
  EOutboundReferralStatus["Cancelled"] = "cancelled";
  EOutboundReferralStatus["Expired"] = "expired";
  EOutboundReferralStatus["Closed"] = "closed";
})(EOutboundReferralStatus || (EOutboundReferralStatus = {}));
export let EOutboundReferralProcessedOutreach;
(function (EOutboundReferralProcessedOutreach) {
  EOutboundReferralProcessedOutreach["Pending"] = "pending";
  EOutboundReferralProcessedOutreach["Skipped"] = "skipped";
  EOutboundReferralProcessedOutreach["Failed"] = "failed";
  EOutboundReferralProcessedOutreach["Success"] = "success";
})(EOutboundReferralProcessedOutreach || (EOutboundReferralProcessedOutreach = {}));
export const fieldsOutboundReferral = _extends({}, fieldsIBaseModel, {
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  attempt: {
    type: 'Number'
  },
  calledAt: {
    type: 'Date'
  },
  diagnoses: {
    type: 'ID',
    ref: EModel.Diagnosis,
    array: true
  },
  expireAt: {
    type: 'Date'
  },
  externalId: {
    type: 'Object'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  faxUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  lastAttemptSentAt: {
    type: 'Date'
  },
  notes: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  processedReferralOutreach: {
    type: 'Option',
    values: EOutboundReferralProcessedOutreach
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  reason: {
    type: 'Text'
  },
  renderingProvider: {
    type: 'ID',
    ref: EModel.Provider
  },
  scheduledAt: {
    type: 'Date'
  },
  source: {
    type: 'Option',
    values: EOutboundReferralSource
  },
  startOn: {
    type: 'Date'
  },
  status: {
    type: 'Option',
    values: EOutboundReferralStatus
  }
});